// AuthProtected.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AuthProtected = (props) => {
    const isLocked = useSelector((state) => state.lock.isLocked); // Get lock status from Redux

    // Function to check if user is in local storage
    const isUserAuthenticated = () => {
        // const user = JSON.parse(localStorage.getItem('user'));
        // return user && user.account;
        const token = localStorage.getItem('token');
        return token;
    };

    // If user is not authenticated, redirect to login page
    if (!isUserAuthenticated()) {
        return <Navigate to="/login" />;
    }

    // If screen is locked, redirect to lock screen
    if (isLocked || localStorage.getItem('isLocked') === 'true') {
        return <Navigate to="/auth-lockscreen-basic" />;
    }

    return <>{props.children}</>;
};

export default AuthProtected;
